module.exports = __webpack_public_path__ + "static/img/PC-1.bc262ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-1.png
// module id = SEVS
// module chunks = 0